export default "__VITE_PUBLIC_ASSET__474e7c17__"